module.exports = __webpack_public_path__ + "img/upload.3b35eaa2.png";